import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { getUser } from '@/store/userStore'
import userMenus from '@/router/menuManage'
import Page404 from '../views/404.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import About from '../views/About.vue'
import PlatformIndex from '../views/index/PlatformIndex.vue'
import ShopIndex from '../views/index/ShopIndex.vue'
import House from '../views/house/HouseList.vue'
import UserList from '../views/user/UserList.vue'
import ShopUserList from '../views/user/ShopUserList.vue'
import GoodsList from '@/views/goods/GoodsList.vue'
import Classify from '@/views/goods/Classify.vue'
import ActivityList from '@/views/activity/ActivityList.vue'
import OrderList from '@/views/order/OrderList.vue'
import BillList from '@/views/bill/BillList.vue'
import PlatformManager from '@/views/platform/PlatformManager.vue'
import Channel from '@/views/channel/Channel.vue'
import EditBrochure from '@/views/brochure/EditBrochure.vue'
import BrochureList from '@/views/brochure/BrochureList.vue'
import InformationList from '@/views/information/InformationList.vue'
import ActivityInfoList from '@/views/activityinfo/ActivityInfoList.vue'
import SupplierList from '@/views/supplier/SupplierList.vue'
import Banner from '@/views/banner/Banner.vue'
import Navigation from '@/views/navigation/navigation.vue'
import VoucherList from '@/views/voucher/VoucherList.vue'
import UserVoucherList from '@/views/voucher/UserVoucherList.vue'
import VideoList from '@/views/video/VideoList.vue'
import ShopList from '@/views/shop/ShopList.vue'
import ShopAudit from '@/views/shop/ShopAudit.vue'
import ShopManage from '@/views/shop/ShopManage.vue'
import MedicineCabinetList from '@/views/medicineCabinet/MedicineCabinetList.vue'
import InvestorList from '@/views/investor/InvestorList.vue'
import BankCodeList from '@/views/bank/BankCodeList.vue'
import SysConfigList from '@/views/sysConfig/SysConfigList.vue'
import SysConfig from '@/views/sysConfig/SysConfig.vue'
import WechatAdReward from '@/views/sysConfig/WechatAdReward.vue'
import CouponTemplateManage from '@/views/sysConfig/CouponTemplateManage.vue'
import CouponGrantLogList from '@/views/sysConfig/CouponGrantLogList.vue'
import CouponUserCouponList from '@/views/sysConfig/CouponUserCouponList.vue'
import CouponOpsCenter from '@/views/sysConfig/CouponOpsCenter.vue'
import UserCheckinConfig from '@/views/sysConfig/UserCheckinConfig.vue'
import UserCheckinRecordList from '@/views/sysConfig/UserCheckinRecordList.vue'
import UserActivityRecordList from '@/views/sysConfig/UserActivityRecordList.vue'
import ActivityDayLeaderboardList from '@/views/sysConfig/ActivityDayLeaderboardList.vue'
import ActivityDailyRankRewardConfig from '@/views/sysConfig/ActivityDailyRankRewardConfig.vue'
import MemberList from '@/views/member/MemberList.vue'
import MemberConfigList from '@/views/memberConfig/MemberConfigList.vue'
import DistributionActivityList from '@/views/distribution/DistributionActivityList.vue'
import UserWealthRecordList from '@/views/distribution/UserWealthRecordList.vue'
import UserPointsRecordList from '@/views/distribution/UserPointsRecordList.vue'
import DistributionActivityRecordList from '@/views/distribution/DistributionActivityRecordList.vue'
import ShopAddressList from '@/views/shop/ShopAddressList.vue'
import PartnerList from '@/views/partner/PartnerList.vue'
import AnnouncementList from '@/views/announcement/AnnouncementList.vue'
import NewsList from '@/views/news/NewsList.vue'
import IndexHomeConfig from '@/views/index/IndexHomeConfig.vue'
import OriginStoryList from '@/views/originStory/OriginStoryList.vue'
import InvoiceTypeList from '@/views/invoiceType/InvoiceTypeList.vue'
import PlatformWealthRecordList from '@/views/distribution/PlatformWealthRecordList.vue'
import MemberAddressConfigList from '@/views/memberAddressConfig/MemberAddressConfigList.vue'



Vue.use(VueRouter)
// 店铺角色组
const shopRoles = [2]
// 平台角色组
const palrformRoles = [1,101,102,103,104,105,201,301]

const routes: Array<RouteConfig> = [
  {
    path: '/',
  },
  {
    path: '/404',
    name: '404',
    meta: {
      title: '404',
    },
    component: Page404,
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页',
    },
    children: [
      {
        path: '/home',
        name: 'platformIndex',
        meta: {
          title: '系统首页',
          role: palrformRoles
        },
        component: PlatformIndex,
      },
      {
        path: '/simpleIndex',
        name: 'simpleIndex',
        meta: {
          title: '系统首页',
        },
        component: ()=> import('@/views/index/SimpleIndex.vue'),
      },
      {
        // 店铺首页
        path: '/shopIndex',
        name: 'ShopIndex',
        meta: {
          title: '系统首页',
          role:shopRoles
        },
        component: ShopIndex,
      },
      {
        path: '/house',
        name: 'house',
        meta: {
          title: '户主管理',
        },
        component: House,
      },
      {
        path: '/userList',
        name: 'userList',
        meta: {
          title: '用户管理',
          role:palrformRoles
        },
        component: UserList,
      },
      {
        path: '/shopUserList',
        name: 'ShopUserList',
        meta: {
          title: '客户列表',
        },
        component: ShopUserList,
      },
      {
        path: '/goodsList',
        name: 'goodsList',
        meta: {
          title: '商品管理',
        },
        component: GoodsList,
      },
      {
        path: '/goodsCommentList',
        name: 'goodsCommentList',
        meta: {
          title: '商品评论',
        },
        component: () => import('@/views/goods/GoodsCommentList.vue'),
      },
      {
        path: '/commentList',
        name: 'commentList',
        meta: {
          title: '评价总列表',
        },
        component: () => import('@/views/goods/CommentList.vue'),
      },
      {
        path: '/indexGoodsList',
        name: 'IndexGoodsList',
        meta: {
          title: ' 首页商品管理',
          role: palrformRoles
        },
        component: ()=> import('@/views/goods/IndexGoodsList.vue'),
      },
      {
        path: '/cityGoods',
        name: 'CityGoods',
        meta: {
          title: ' 一县一特',
          role: palrformRoles
        },
        component: ()=> import('@/views/goods/CityGoods.vue'),
      },
      {
        path: '/paymentDiscountGoodsList',
        name: 'PaymentDiscountGoodsList',
        meta: {
          title: '支付立减商品管理',
          role: palrformRoles
        },
        component: ()=> import('@/views/goods/PaymentDiscountGoodsList.vue'),
      },
      {
        path: '/goodsAuditList',
        name: 'goodsAuditList',
        meta: {
          title: '商品审核',
          role: palrformRoles
        },
       component: () => import('@/views/goods/GoodsAuditList.vue'),
      },
      {
        path: '/activityList',
        name: 'activityList',
        meta: {
          title: '活动管理',
          role: palrformRoles
        },
        component: ActivityList,
      },
      {
        path: '/classify',
        name: 'classify',
        meta: {
          title: '分类',
          role: palrformRoles
        },
        component: Classify,
      },
      {
        path: '/orderList',
        name: 'orderList',
        meta: {
          title: '订单管理',
        },
        component: OrderList,
      },
      {
        path: '/settlementOrderList',
        name: 'settlementOrderList',
        meta: {
          title: '结算订单',
        },
        component:  () => import('@/views/order/SettlementOrderList.vue'),
      },
      {
        path: '/allocateErrorRecord',
        name: 'allocateErrorRecord',
        meta: {
          title: '分佣执行异常记录',
        },
        component:  () => import('@/views/order/AllocateErrorRecord.vue'),
      },
      {
        path: '/kuaidi100SubscribePending',
        name: 'kuaidi100SubscribePending',
        meta: {
          title: '快递100订阅失败',
        },
        component: () => import('@/views/order/Kuaidi100SubscribePendingList.vue'),
      },
      {
        path: '/billList',
        name: 'billList',
        meta: {
          title: '账单列表',
          role: palrformRoles
        },
        component: BillList,
      },
      {
        path: '/platformManager',
        name: 'platformManager',
        meta: {
          title: '后台用户管理',
          role: palrformRoles
        },
        component: PlatformManager,
      },
      {
        path: '/shopPlatformManager',
        name: 'shopPlatformManager',
        meta: {
          title: '后台用户管理',
          role: palrformRoles
        },
        component: () => import('@/views/platform/ShopPlatformManager.vue'),
      },
      {
        path: '/channel',
        name: 'channel',
        meta: {
          title: '渠道管理',
          role: palrformRoles
        },
        component: Channel,
      },
      {
        path: '/editBrochure',
        name: 'editBrochure',
        meta: {
          title: '编辑宣传页',
          role: palrformRoles
        },
        component: EditBrochure,
      },
      {
        path: '/brochureList',
        name: 'brochureList',
        meta: {
          title: '宣传页',
          role: palrformRoles
        },
        component: BrochureList,
      },
      {
        path: '/informationList',
        name: 'informationList',
        meta: {
          title: '资讯管理',
          role: palrformRoles
        },
        component: InformationList,
      },
      {
        path: '/activityInfoList',
        name: 'activityInfoList',
        meta: {
          title: '社区活动',
          role: palrformRoles
        },
        component: ActivityInfoList,
      },
      {
        path: '/supplierList',
        name: 'supplierList',
        meta: {
          title: '供应商管理',
          role: palrformRoles
        },
        component: SupplierList,
      },
      {
        path: '/banner',
        name: 'banner',
        meta: {
          title: 'banner',
          role: palrformRoles
        },
        component: Banner,
      },
      {
        path: '/navigation',
        name: 'navigation',
        meta: {
          title: '导航栏',
          role: palrformRoles
        },
        component: Navigation,
      },
      {
        path: '/voucherList',
        name: 'voucherList',
        meta: {
          title: '提货卷模版管理',
          role: palrformRoles
        },
        component: VoucherList,
      },
      {
        path: '/userVoucherList',
        name: 'userVoucherList',
        meta: {
          title: '用户提货卷',
          role: palrformRoles
        },
        component: UserVoucherList,
      },
      {
        path: '/videoList',
        name: 'videoList',
        meta: {
          title: '视频管理',
          role: palrformRoles
        },
        component: VideoList,
      },
      {
        path: '/shopList',
        name: 'shopList',
        meta: {
          title: '店铺管理',
          role: palrformRoles
        },
        component: ShopList,
      },
      {
        path: '/shopAudit',
        name: 'ShopAudit',
        meta: {
          title: '店铺审核',
          role: palrformRoles
        },
        component: ShopAudit,
      },
      {
        path: '/shopWealthRecordList',
        name: 'ShopWealthRecordList',
        meta: {
          title: '店铺流水',
          role: palrformRoles
        },
        component: () => import('@/views/shop/ShopWealthRecordList.vue'),
      },
      {
        path: '/shopWealthRecordListForShop',
        name: 'ShopWealthRecordListForShop',
        meta: {
          title: '店铺流水',
        },
        component: () => import('@/views/shop/ShopWealthRecordListForShop.vue'),
      },

      {
        path: '/agreeApply/resultPage',
        name: 'AgreeApplyResultPage',
        meta: {
          title: '免密提现协议结果',
        },
       component: () => import('@/views/shop/AgreeApplyResultPage.vue'),
      },
      {
        path: '/shopManage',
        name: 'ShopManage',
        meta: {
          title: '店铺管理',
          role: shopRoles
        },
        component: ShopManage,
      },
      {
        path: '/medicineCabinetList',
        name: 'medicineCabinetList',
        meta: {
          title: '药柜管理',
          role: palrformRoles
        },
        component: MedicineCabinetList,
      },
      {
        path: '/investorList',
        name: 'investorList',
        meta: {
          title: '投资数据管理',
          role: palrformRoles
        },
        component: InvestorList,
      },
      {
        path: '/bankCodeList',
        name: 'BankCodeList',
        meta: {
          title: '银行管理',
          role: palrformRoles
        },
        component: BankCodeList,
      },
      {
        path: '/sysConfigList',
        name: 'SysConfigList',
        meta: {
          title: '系统设置列表',
          role: palrformRoles
        },
        component: SysConfigList,
      },
      {
        path: '/sysConfig',
        name: 'sysConfig',
        meta: {
          title: '系统设置',
          role: palrformRoles
        },
        component: SysConfig,
      },
      {
        path: '/wechatAdReward',
        name: 'wechatAdReward',
        meta: {
          title: '广告奖励配置',
          role: palrformRoles
        },
        component: WechatAdReward,
      },
      {
        path: '/couponTemplateManage',
        name: 'couponTemplateManage',
        meta: {
          title: '券模板',
          role: palrformRoles
        },
        component: CouponTemplateManage,
      },
      {
        path: '/couponUserCouponList',
        name: 'couponUserCouponList',
        meta: {
          title: '用户券',
          role: palrformRoles
        },
        component: CouponUserCouponList,
      },
      {
        path: '/couponGrantLogList',
        name: 'couponGrantLogList',
        meta: {
          title: '发放记录',
          role: palrformRoles
        },
        component: CouponGrantLogList,
      },
      {
        path: '/couponOpsCenter',
        name: 'couponOpsCenter',
        meta: {
          title: '优惠券运营中心',
          role: palrformRoles
        },
        component: CouponOpsCenter,
      },
      {
        path: '/userCheckinConfig',
        name: 'userCheckinConfig',
        meta: {
          title: '签到活跃度配置',
          role: palrformRoles
        },
        component: UserCheckinConfig,
      },
      {
        path: '/userCheckinRecordList',
        name: 'userCheckinRecordList',
        meta: {
          title: '签到记录',
          role: palrformRoles
        },
        component: UserCheckinRecordList,
      },
      {
        path: '/userActivityRecordList',
        name: 'userActivityRecordList',
        meta: {
          title: '活跃度流水',
          role: palrformRoles
        },
        component: UserActivityRecordList,
      },
      {
        path: '/activityDayLeaderboard',
        name: 'activityDayLeaderboard',
        meta: {
          title: '日活跃度排行榜',
          role: palrformRoles
        },
        component: ActivityDayLeaderboardList,
      },
      {
        path: '/activityDailyRankRewardConfig',
        name: 'activityDailyRankRewardConfig',
        meta: {
          title: '日活跃度排行奖励',
          role: palrformRoles
        },
        component: ActivityDailyRankRewardConfig,
      },
       {
        path: '/memberList',
        name: 'memberList',
        meta: {
          title: '会员管理列表',
          role: palrformRoles
        },
        component: MemberList,
      },
       {
        path: '/partnerList',
        name: 'partnerList',
        meta: {
          title: '合伙人管理列表',
          role: palrformRoles
        },
        component: PartnerList,
      },
      {
        path: '/memberConfigList',
        name: 'memberConfigList',
        meta: {
          title: '代理设置列表',
          role: palrformRoles
        },
        component: MemberConfigList,
      },
       {
        path: '/distributionActivityList',
        name: 'distributionActivityList',
        meta: {
          title: '绿豆管理',
          role: palrformRoles
        },
        component: DistributionActivityList,
      },
      {
        path: '/userWealthRecordList',
        name: 'userWealthRecordList',
        meta: {
          title: '用户积分记录',
          role: palrformRoles
        },
        component: UserWealthRecordList,
      },
      {
        path: '/userPointsRecordList',
        name: 'userPointsRecordList',
        meta: {
          title: '积分明细',
          role: palrformRoles
        },
        component: UserPointsRecordList,
      },
      {
        path: '/distributionActivityRecordList',
        name: 'distributionActivityRecordList',
        meta: {
          title: '绿豆发放记录',
          role: palrformRoles
        },
        component: DistributionActivityRecordList,
      },
      {
        path: '/mungBeanAllocateBatchList',
        name: 'mungBeanAllocateBatchList',
        meta: {
          title: '分配充值批次',
          role: palrformRoles
        },
        component: () => import('@/views/distribution/MungBeanAllocateBatchList.vue'),
      },
      {
        path: '/mungBeanAllocateDetailList',
        name: 'mungBeanAllocateDetailList',
        meta: {
          title: '分配充值明细',
          role: palrformRoles
        },
        component: () => import('@/views/distribution/MungBeanAllocateDetailList.vue'),
      },
      {
        path: '/mungBeanAllocateSedimentList',
        name: 'mungBeanAllocateSedimentList',
        meta: {
          title: '分配充值沉淀',
          role: palrformRoles
        },
        component: () => import('@/views/distribution/MungBeanAllocateSedimentList.vue'),
      },
      {
        path: '/specialPricePoolManage',
        name: 'specialPricePoolManage',
        meta: {
          title: '特价商品平台池',
          role: palrformRoles
        },
        component: () => import('@/views/distribution/SpecialPricePoolManage.vue'),
      },
      {
        path: '/withdrawAuditList',
        name: 'withdrawAuditList',
        meta: {
          title: '提现审核',
          role:[1,201,105]
        },
        component: () => import('@/views/withdraw/withdrawAuditList.vue'),
      },
      {
        path: '/shopSpecialRefund',
        name: 'shopSpecialRefund',
        meta: {
          title: '特殊关单退绿豆',
          role: [1, 201, 105]
        },
        component: () => import('@/views/shop/ShopSpecialRefund.vue'),
      },
      {
        path: '/shopWithdrawRecord',
        name: 'shopWithdrawRecord',
        meta: {
          title: '店铺提现记录',

        },
        component: () => import('@/views/withdraw/shopWithdrawRecord.vue'),
      },
      {
        path: '/bankCardList',
        name: 'BankCardList',
        meta: {
          title: '银行卡列表'
        },
        component: () => import('@/views/bank/BankCardList.vue'),
      },
      {
        path: '/shopAddressList',
        name: 'shopAddressList',
        meta: {
          title: '店铺收货地址',
        },
        component: ShopAddressList,
      },
       {
        path: '/createGoodsPage',
        name: 'createGoodsPage',
        meta: {
          title: '编辑商品',
        },
        component: () => import('@/views/goods/CreateGoodsPage.vue'),
      },
      {
        path: '/announcementList',
        name: 'announcementList',
        meta: {
          title: '公告管理',
          role: palrformRoles
        },
        component: AnnouncementList,
      },
      {
        path: '/invoiceTypeList',
        name: 'invoiceTypeList',
        meta: {
          title: '发票类型管理',
          role: palrformRoles
        },
        component: InvoiceTypeList,
      },
      {
        path: '/newsList',
        name: 'newsList',
        meta: {
          title: '文章管理',
          role: palrformRoles
        },
        component: NewsList,
      },
      {
        path: '/indexHomeConfig',
        name: 'indexHomeConfig',
        meta: {
          title: '首页配置',
          role: palrformRoles
        },
        component: IndexHomeConfig,
      },
      {
        path: '/originStoryList',
        name: 'originStoryList',
        meta: {
          title: '产地故事',
          role: palrformRoles
        },
        component: OriginStoryList,
      },
      {
        path: '/platformWealthRecordList',
        name: 'platformWealthRecordList',
        meta: {
          title: '平台pv流水',
          role: palrformRoles
        },
        component: PlatformWealthRecordList,
      },
      {
        path: '/memberAddressConfigList',
        name: 'memberAddressConfigList',
        meta: {
          title: '区域代理设置',
          role: palrformRoles
        },
        component: MemberAddressConfigList,
      },
      {
        path: '/system/log',
        name: 'systemLog',
        meta: {
          title: '日志管理',
          role: palrformRoles
        },
        component: () => import('@/views/system/log/index.vue'),
      },
      {
        path: '/statistical/financeStatisticalIndex',
        name: 'financeStatisticalIndex',
        meta: {
          title: '财务统计',
          role: palrformRoles
        },
        component: () => import('@/views/statistical/financeStatisticalIndex.vue'),
      },
      {
        path: '/statistical/dailySalesStatList',
        name: 'dailySalesStatList',
        meta: {
          title: '每日销售数据统计',
          role: palrformRoles
        },
        component: () => import('@/views/statistical/dailySalesStatList.vue'),
      },
      {
        path: '/statistical/energyContributionStatList',
        name: 'energyContributionStatList',
        meta: {
          title: '每日能量值/贡献值数据统计',
          role: palrformRoles
        },
        component: () => import('@/views/statistical/energyContributionStatList.vue'),
      },
      {
        path: '/statistical/mengBeanSummaryList',
        name: 'mengBeanSummaryList',
        meta: {
          title: '每日绿豆数据统计',
          role: palrformRoles
        },
        component: () => import('@/views/statistical/mengBeanSummaryList.vue'),
      },
      {
        path: '/statistical/platformPvSummaryList',
        name: 'platformPvSummaryList',
        meta: {
          title: '每日平台PV数据统计',
          role: palrformRoles
        },
        component: () => import('@/views/statistical/platformPvSummaryList.vue'),
      },
      {
        path: '/statistical/withdrawMerchantBalanceStatList',
        name: 'withdrawMerchantBalanceStatList',
        meta: {
          title: '每日提现数据统计',
          role: palrformRoles
        },
        component: () => import('@/views/statistical/withdrawMerchantBalanceStatList.vue'),
      },
      {
        path: '/statistical/financeSalesStatList',
        name: 'financeSalesStatList',
        meta: {
          title: '财务销售明细统计',
          role: palrformRoles
        },
        component: () => import('@/views/statistical/financeSalesStatList.vue'),
      },
      {
        path: '/statistical/financeMungBeanStatList',
        name: 'financeMungBeanStatList',
        meta: {
          title: '财务绿豆明细统计',
          role: palrformRoles
        },
        component: () => import('@/views/statistical/financeMungBeanStatList.vue'),
      },
      {
        path: '/statistical/financeAllocateRechargeDailyStatList',
        name: 'financeAllocateRechargeDailyStatList',
        meta: { title: '分配充值日汇总', role: palrformRoles },
        component: () => import('@/views/statistical/financeAllocateRechargeDailyStatList.vue'),
      },
      {
        path: '/statistical/financeSpecialPriceDailyStatList',
        name: 'financeSpecialPriceDailyStatList',
        meta: { title: '特价订单日汇总', role: palrformRoles },
        component: () => import('@/views/statistical/financeSpecialPriceDailyStatList.vue'),
      },
      {
        path: '/statistical/financeDistributionDailyStatList',
        name: 'financeDistributionDailyStatList',
        meta: { title: '分销复购日汇总', role: palrformRoles },
        component: () => import('@/views/statistical/financeDistributionDailyStatList.vue'),
      },
      {
        path: '/statistical/financeBizPvReconcileDailyStatList',
        name: 'financeBizPvReconcileDailyStatList',
        meta: { title: '业务PV勾稽日汇总', role: palrformRoles },
        component: () => import('@/views/statistical/financeBizPvReconcileDailyStatList.vue'),
      },
      {
        path: '/statistical/financeWealthWayDailyList',
        name: 'financeWealthWayDailyList',
        meta: { title: '账户流水way_type日汇总', role: palrformRoles },
        component: () => import('@/views/statistical/financeWealthWayDailyList.vue'),
      },
      {
        path: '/statistical/financeWealthWayCategoryList',
        name: 'financeWealthWayCategoryList',
        meta: { title: '流水大类归类明细', role: palrformRoles },
        component: () => import('@/views/statistical/financeWealthWayCategoryList.vue'),
      },
      {
        path: '/statistical/financeAssetDailyBalanceList',
        name: 'financeAssetDailyBalanceList',
        meta: { title: '资产日终余额勾稽', role: palrformRoles },
        component: () => import('@/views/statistical/financeAssetDailyBalanceList.vue'),
      },
      {
        path: '/statistical/financeAsOfStat',
        name: 'financeAsOfStat',
        meta: { title: '财务截止日汇总', role: palrformRoles },
        component: () => import('@/views/statistical/components/FinanceAsOfStatPanel.vue'),
      },
      {
        path: '/userMember/userMemberChangeRecord',
        name: 'userMemberChangeRecord',
        meta: {
          title: '用户会员等级变更记录',
          role: palrformRoles
        },
        component: () => import('@/views/user/UserMemberChangeRecord.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '登录',
    },
    component: Login,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  // 设置页面头部
  let title = ''
  let role = undefined
  if (to.meta) {
    title = to.meta.title
    role = to.meta.role
  } else {
    title = '后台管理系统'
  }
  document.title = title

  const userInfo = getUser()
  const userName = userInfo?.userName
  const userRole = userInfo?.user?.role
  // 权限判断和登录判断
  if (!userName && to.path !== '/login') {
    next('/login')
  } else if(role){
    // 判定角色
    if(Array.isArray(role)){
      if(role.indexOf(userRole) < 0){
        next("/404")
      } else {
        next()
      }
    } else if(role == userRole){
      next()
    } else {
      next("/404")
    }
  } else if(to.path === '/'){
    if(userRole == 2 ){
      next('/shopIndex')
    } else {
      // 获取/home 是否存在
      const um = userMenus()
      if(um.filter(e=>e.index == '/home').length > 0){
        // 获取配置的
        next('/home')
      } else if(um.filter(e=>e.index == '/simpleIndex').length > 0){
        // 获取配置的
        next('/simpleIndex')
      } else {
        // 获取配置的
        next('/home')
      }

    }
  } else {
    next()
  }
})

export default router
